import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateCompanyAction } from '../../../api/redux/slices/SuperAdmin';
import 'react-toastify/dist/ReactToastify.css';
import { showToast } from '../../../components/modal';

const UpdateCompany = ({ lineIndice, modalOpen, setModalOpen }) => {
    const { listCompanies } = useSelector((state) => state.superAdmin);
    const [infos, setInfos] = useState(...listCompanies.filter((el) => el._id === lineIndice));
    const dispatch = useDispatch();
    const [isFocus, setIsFocus] = useState(false);
    const token = localStorage.getItem('accesstoken');

    useEffect(() => {
        setInfos(...listCompanies.filter((el) => el._id === lineIndice));
    }, [lineIndice, listCompanies, modalOpen]);

    const [values, setValues] = useState({
        name: infos?.name || '',
        address: infos?.address || '',
        phone: infos?.phone || '',
        fax: infos?.fax || '',
        email: infos?.email || '',
        tva_code: infos?.tva_code || '',
        r_c: infos?.r_c || '',
        customs_code: infos?.customs_code || '',
    });

    useEffect(() => {
        if (infos) {
            setValues({
                name: infos?.name || '',
                address: infos?.address || '',
                phone: infos?.phone || '',
                fax: infos?.fax || '',
                email: infos?.email || '',
                tva_code: infos?.tva_code || '',
                r_c: infos?.r_c || '',
                customs_code: infos?.customs_code || '',
            });
        }
    }, [infos]);

    const handleUpdate = (e) => {
        e.preventDefault();
        const data = {
            name: values.name.trim(),
            address: values.address.trim(),
            phone: values.phone.trim(),
            fax: values.fax.trim(),
            email: values.email.trim(),
            tva_code: values.tva_code.trim(),
            r_c: values.r_c.trim(),
            customs_code: values.customs_code.trim(),
            is_active: true,
        };
        if (!data.name) {
            showToast('Veuillez remplir le nom de la société', 'warn');
            return;
        }
        dispatch(updateCompanyAction({ token: token, id: lineIndice, data: data }))
            .unwrap()
            .then(() => {
                showToast('Société modifiée avec succès', 'success');
                setModalOpen(false);
            })
            .catch((err) => showToast(err.message || err.error, 'error'));
    };

    return (
        <div className={'modalcontainer ' + (modalOpen && 'open')}>
            <div className={'modal ' + (modalOpen && 'active')}>
                <form onSubmit={handleUpdate}>
                    <div className='label-input'>
                        <label>Nom de la société</label>
                        <input
                            type='text'
                            placeholder='Nom'
                            value={values.name}
                            onChange={(e) => {
                                setValues({ ...values, name: e.target.value });
                                setIsFocus(true);
                            }}
                            required
                        />
                    </div>
                    <div className='label-input'>
                        <label>Adresse</label>
                        <input
                            type='text'
                            placeholder='Adresse'
                            value={values.address}
                            onChange={(e) => {
                                setValues({ ...values, address: e.target.value });
                                setIsFocus(true);
                            }}
                        />
                    </div>
                    <div className='label-input'>
                        <label>Téléphone</label>
                        <input
                            type='text'
                            placeholder='Téléphone'
                            value={values.phone}
                            onChange={(e) => {
                                setValues({ ...values, phone: e.target.value });
                                setIsFocus(true);
                            }}
                        />
                    </div>
                    <div className='label-input'>
                        <label>Fax</label>
                        <input
                            type='text'
                            placeholder='Fax'
                            value={values.fax}
                            onChange={(e) => {
                                setValues({ ...values, fax: e.target.value });
                                setIsFocus(true);
                            }}
                        />
                    </div>
                    <div className='label-input'>
                        <label>Email</label>
                        <input
                            type='email'
                            placeholder='Email'
                            value={values.email}
                            onChange={(e) => {
                                setValues({ ...values, email: e.target.value });
                                setIsFocus(true);
                            }}
                        />
                    </div>
                    <div className='label-input'>
                        <label>Code TVA</label>
                        <input
                            type='text'
                            placeholder='Code TVA'
                            value={values.tva_code}
                            onChange={(e) => {
                                setValues({ ...values, tva_code: e.target.value });
                                setIsFocus(true);
                            }}
                        />
                    </div>
                    <div className='label-input'>
                        <label>Registre de commerce (R.C)</label>
                        <input
                            type='text'
                            placeholder='Registre de commerce'
                            value={values.r_c}
                            onChange={(e) => {
                                setValues({ ...values, r_c: e.target.value });
                                setIsFocus(true);
                            }}
                        />
                    </div>
                    <div className='label-input'>
                        <label>Code douane</label>
                        <input
                            type='text'
                            placeholder='Code douane'
                            value={values.customs_code}
                            onChange={(e) => {
                                setValues({ ...values, customs_code: e.target.value });
                                setIsFocus(true);
                            }}
                        />
                    </div>
                    <div className='submit-btns'>
                        <div className='add-btns'>
                            <button
                                className={isFocus ? 'button-nature' : 'button-nature-inactive'}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setModalOpen(false);
                                }}
                            >
                                Annuler
                            </button>
                            <button
                                className={isFocus ? 'button-primary' : 'button-primary-inactive'}
                                type='submit'
                            >
                                Modifier
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UpdateCompany;